<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<colgroup>
						<col width="180" />
						<col />
						<col width="180" />
						<col />
					</colgroup>
					<tr>
						<th>项目名称</th>
						<td>{{ biddingDetail.projectName }}</td>
						<th>工程名称</th>
						<td>{{ biddingDetail.engineeringName }}</td>
					</tr>
					<tr>
						<th>所在地市</th>
						<td>{{ biddingDetail.cityName }}</td>
						<th>所在区县</th>
						<td>{{ biddingDetail.countyName }}</td>
					</tr>
					<tr>
						<th>招投标环节编码</th>
						<td>{{ biddingDetail.linkCode }}</td>
						<th>中标通知书编号</th>
						<td>{{ biddingDetail.awardNoticeCode }}</td>
					</tr>
					<tr>
						<th>招标类型</th>
						<td>{{ biddingDetail.tenderTypeName }}</td>
						<th>招标方式</th>
						<td>{{ biddingDetail.tenderMethodName }}</td>
					</tr>
					<tr>
						<th>中标日期</th>
						<td>{{ biddingDetail.biddingDate }}</td>
						<th>中标金额(万元)</th>
						<td>{{ biddingDetail.biddingMoney }}</td>
					</tr>
					<tr>
						<th>建设规模</th>
						<td>{{ biddingDetail.constructionScale }}</td>
						<th>面积(平方米)</th>
						<td>{{ biddingDetail.constructionArea }}</td>
					</tr>
					<tr>
						<th>招标代理单位名称</th>
						<td>{{ biddingDetail.agentUnitName }}</td>
						<th>招标代理单位唯一代码</th>
						<td>{{ biddingDetail.agentUnitCode }}</td>
					</tr>
					<tr>
						<th>中标单位名称</th>
						<td>{{ biddingDetail.biddingUnitName }}</td>
						<th>中标单位唯一代码</th>
						<td>{{ biddingDetail.biddingUnitCode }}</td>
					</tr>
					<tr>
						<th>单位资质证书编号</th>
						<td>{{ biddingDetail.unitCertCode }}</td>
						<th>安全生产许可证号</th>
						<td>{{ biddingDetail.workSafetyLicenseCode }}</td>
					</tr>
					<tr>
						<th>项目负责人姓名</th>
						<td>{{ biddingDetail.principalName }}</td>
						<th>记录登记时间</th>
						<td>{{ biddingDetail.registerTime }}</td>
					</tr>
				</table>
			</div>
		</div>
		<!-- 未开通会员提示 -->
		<nonbind-vip v-if="isVip"></nonbind-vip>
		<!-- 未开通超级会员提示 -->
		<nonbind-svip v-if="isSVip"></nonbind-svip>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import { transObject } from '@/utils/index'
	import { getProjectBiddingDetail } from '@/api/qualificationQuery/project'

	// 招投标信息详情
	export default {
		name: 'BiddingInformationDetails',
		components: { NonbindVip, NonbindSvip },
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			}
		},
		data() {
			return {
				// 数据加载状态
				loading: false,
				isVip: false,
				isSVip: false,
				// 招投标信息详情
				biddingDetail: {
					// 项目名称
					projectName: '',
					// 工程名称
					engineeringName: '',
					// 所在地市
					cityCode: '',
					cityName: '',
					// 所在区县
					countyCode: '',
					countyName: '',
					// 招投标环节编码
					linkCode: '',
					// 中标通知书编号
					awardNoticeCode: '',
					// 招标类型
					tenderType: '',
					tenderTypeName: '',
					// 招标方式
					tenderMethod: '',
					tenderMethodName: '',
					// 中标日期
					biddingDate: '',
					// 中标金额(万元)
					biddingMoney: '',
					// 建设规模
					constructionScale: '',
					// 面积(平方米)
					constructionArea: '',
					// 招标代理单位名称
					agentUnitName: '',
					// 招标代理单位唯一代码
					agentUnitCode: '',
					// 中标单位名称
					biddingUnitName: '',
					// 中标单位唯一编码
					biddingUnitCode: '',
					// 单位资质证书编号
					unitCertCode: '',
					// 安全生产许可证号
					workSafetyLicenseCode: '',
					// 项目负责人姓名
					principalName: '',
					// 记录登记时间
					registerTime: ''
				},
				message: ''
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.handleQueryBiddingInfoDetail()
		},
		methods: {
			// 查询施工图审查详情
			handleQueryBiddingInfoDetail() {
				this.loading = true
				const params = {
					projectBiddingInformationId: this.id
				}

				getProjectBiddingDetail(params)
					.then(response => {
						const { data, code, message } = response

						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								// 将目标数据转为我指定的属性对象
								transObject(data, this.biddingDetail)
							}
						}
						this.loading = false
					})
					.catch(error => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
